import { render, staticRenderFns } from "./PricelistButtonComponent.vue?vue&type=template&id=44b74a24"
import script from "./PricelistButtonComponent.vue?vue&type=script&lang=ts"
export * from "./PricelistButtonComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports